import { render, staticRenderFns } from "./editPublish.vue?vue&type=template&id=1be687fa&scoped=true"
import script from "./editPublish.vue?vue&type=script&lang=js"
export * from "./editPublish.vue?vue&type=script&lang=js"
import style0 from "./editPublish.vue?vue&type=style&index=0&id=1be687fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be687fa",
  null
  
)

export default component.exports